import { AnimatePresence, motion, type Variants } from "motion/react";
import type { FC, PropsWithChildren } from "react";

interface FormTransitionProps extends PropsWithChildren {
	keyProp: string | number;
	disableExitAnimation?: boolean;
}

export const FormWizardAnimation: FC<FormTransitionProps> = ({
	children,
	keyProp,
	disableExitAnimation = false,
}) => {
	return (
		<AnimatePresence mode="wait">
			<motion.div
				key={keyProp}
				variants={formVariants(disableExitAnimation)}
				initial="initial"
				animate="animate"
				exit={disableExitAnimation ? undefined : "exit"}
				transition={{ duration: 0.5, ease: "easeInOut" }}
				style={{ width: "100%" }}
			>
				{children}
			</motion.div>
		</AnimatePresence>
	);
};

const formVariants = (disableExitAnimation: boolean): Variants => ({
	initial: { x: "100%", opacity: 0 },
	animate: { x: 0, opacity: 1 },
	exit: disableExitAnimation ? {} : { x: "-100%", opacity: 0 },
});
